module.exports = __webpack_public_path__ + "static/team-30-6d07f78edaa7833c5fa66fcd1b536140.jpg";